<template lang="pug">
el-dialog.dialog-tracking-notes(:visible='visible', :before-close='exit', :show-close='false')
  h1.ui.header(slot='title')
    | {{(room || {}).no}}
    .sub.header 状态跟踪
  .list
    .row(
      v-for='(row, i) in notes',
      v-if='showChecked || !checked[i]'
      :class='{ semitrans: i === notes.length-1 || row.state || !row.note }'
    )
      el-checkbox(
        v-model='row.state'
        :disabled='frozen[i]'
        @input='oncheck(row, i)'
        :class='{invisible: i === notes.length-1}'
      )
      el-input(
        v-model='row.note'
        :disabled='frozen[i]'
        @input='onchange(row, i)'
        :placeholder='i===notes.length-1 ? "新增条目..." : (!row.note ? "[ 删除该项 ]" : "")'
      )
      el-select(
        v-model='row.tags'
        :disabled='frozen[i]'
        multiple
        placeholder='标签'
      )
        el-option(v-for='tag in tags', :key='tag', :label='tag', :value='tag')

      .time(:class='{invisible: i === notes.length-1}') {{row._modifier}} / {{$formatters.date.to_datetime_short(row.time_modified)}}
  div(slot='footer')
    el-checkbox(v-model='showChecked' label='显示已完成' style="margin-right: 10px")
    .ui.button.themed(@click='save') 保存
    .ui.button(@click='exit') 取消
</template>

<script>
export default {
  name: 'dialog-tracking-notes',
  props: {
    room: Object,
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      showChecked: false,
      notes: [],
      frozen: [],
      checked: [],
    }
  },
  computed: {
    tags() {
      return this.$store.state.summary.meta.room_notes_tags || []
    },
  },
  mounted() {
    this.init()
  },
  watch: {
    room: {
      deep: true,
      handler() {
        this.init()
      },
    },
    visible() {
      if (this.visible)
        this.init()
    },
  },
  methods: {
    init() {
      this.notes = JSON.parse(JSON.stringify((this.room || {}).tracking_notes || []))
        .map(n => {
          n.tags = n.tags || []
          return n
        })
      this.frozen = this.notes.map(n => {
        if (this.$permission.has('notes.full_control'))
          return false
        if (n.state)
          return true
        if (n._modifier !== this.$user.get_name())
          return true
        if (this.$moment() - n.time_modified > 1000 * 60 * 60 * 24)
          return true
        return false
      })
      this.checked = this.notes.map(i => i.state)
      this.insert()
    },
    oncheck(row) {
      row._modifier = this.$user.get_name()
      row.time_modified = this.$moment()
    },
    onchange(row, index) {
      if (index === this.notes.length - 1 && row.note)
        this.insert()
    },
    getTag(row) {
      return Array.from(row.tags || []).join(',')
    },
    setTag(row, value) {
      row.tags = value.split(',')
    },
    insert() {
      this.notes.push({
        note: '',
        state: false,
        time_created: this.$moment(),
        time_modified: this.$moment(),
        tags: [],
        _creator: this.$user.get_name(),
        _modifier: this.$user.get_name(),
      })
    },
    save() {
      this.$http.put(`rooms/${this.room._id}/tracking_notes`, this.notes.filter(i => i.note))
        .then(r => {
          this.room.tracking_notes = r.body.tracking_notes
          this.$store.commit('UPDATE_TRACKING_NOTES', { room_id: this.room._id, notes: r.body.tracking_notes })
          this.$emit('update:tracking_notes', this.room.tracking_notes)
          this.exit()
        })
        .catch(this.$utils.DefaultErrorHandler.bind(this))
    },
    exit() {
      this.$emit('update:visible', false)
    },
  },
}
</script>



// WEBPACK FOOTER //
// DialogTrackingNotes.vue?661b6061